export interface GlPeriod {
  month: number;
  year: number;
}

export const getDefaultGlPeriod = (): GlPeriod => ({
  year: new Date().getFullYear(),
  month: new Date().getMonth() + 1,
});

export const parseValueToGlPeriod = (value: string): GlPeriod => {
  if (!value) {
    return getDefaultGlPeriod();
  }
  return {
    year: parseInt(value.toString().slice(0, 4), 10),
    month: parseInt(value.toString().slice(4, 6), 10),
  };
};

export const parseGlPeriodToNumber = (value?: GlPeriod): number => {
  if (!value) {
    value = getDefaultGlPeriod();
  }
  return value.year * 100 + value.month;
};

export const parseDateValueToGlPeriod = (value: Date): GlPeriod => {
  if (!value) {
    return getDefaultGlPeriod();
  }
  return {
    year: value.getFullYear(),
    month: value.getMonth() + 1,
  };
};

export const formatGlPeriodToLongFormat = (
  glPeriod: GlPeriod,
  locale: string,
): string => {
  const date = new Date(glPeriod.year, glPeriod.month - 1);
  return date.toLocaleDateString(locale, { year: 'numeric', month: 'long' });
};

export const addMonthToPeriod = (glPeriod: GlPeriod): GlPeriod => {
  let year = glPeriod.year;
  let month = glPeriod.month;
  month += 1;
  if (month > 12) {
    month = 1;
    year += 1;
  }
  return {
    year,
    month,
  };
};
export const substituteMonthFromPeriod = (glPeriod: GlPeriod): GlPeriod => {
  let year = glPeriod.year;
  let month = glPeriod.month;
  month -= 1;
  if (month < 1) {
    month = 12;
    year -= 1;
  }
  return {
    year,
    month,
  };
};
export const getMonthsDifferenceBetweenPeriods = (
  startPeriod: number,
  endPeriod: number,
): number => {
  const startingPeriod = parseValueToGlPeriod(startPeriod.toString());
  const endingPeriod = parseValueToGlPeriod(endPeriod.toString());
  const monthDifference = endingPeriod.month - startingPeriod.month;
  const yearDifference = endingPeriod.year - startingPeriod.year;
  return monthDifference + yearDifference * 12;
};

export const parseNumberToGlPeriod = (value: number): GlPeriod => {
  const valueStr = value.toString();

  if (valueStr.length !== 6) {
    throw new Error(
      `Invalid GL period format: expected 6 digits, got ${valueStr.length}`,
    );
  }
  if (value < 0) {
    throw new Error('GL period value must be a positive number');
  }

  const year = parseInt(valueStr.slice(0, 4), 10);
  const month = parseInt(valueStr.slice(4, 6), 10);

  if (month < 1 || month > 12) {
    throw new Error(
      `Invalid month value: ${month}. Month must be between 01 and 12`,
    );
  }
  return {
    year,
    month,
  };
};
